import styled, { css } from 'styled-components'
import { BREAK_POINT_SM } from '@CSSVars/variables'
import { FONT_BASE_COLOR, SITE_NAVY_COLOR } from '@CSSVars/colors'

export const _BuildingList = styled.div`
  position: relative;
`

export const buildingTitleCss = css`
  font-size: 14px !important;
  font-weight: normal;
  line-height: 18px;
  margin-top: 7px;
  color: ${FONT_BASE_COLOR};
`

export const _Deleting = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #d3d3d345;
  z-index: 1;
`

export const _BuildingCheckBox = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  background: ${SITE_NAVY_COLOR};
  text-align: center;
  line-height: 20px;
  font-size: 22px;
  &:hover {
    cursor: pointer;
  }
  svg {
    margin-top: 2px;
    fill: white;
    vertical-align: middle;
  }
  border-top-right-radius: 10px;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
